var BaseViews = require('../../base');

require('./cart-items/cart-items.scss');

var CartEmpty = BaseViews.ItemView.extend({
    className: 'fmcy-cart-items-empty',
    template: function() {
        return 'Your cart is currently empty';
    }
});

var CartItem = require('./cart-item');

var CartItems = Marionette.CollectionView.extend({
    className: 'fmcy-cart-items',
    emptyView: CartEmpty,
    childView: CartItem,
    childViewOptions: function(model, index) {
        return {
            errors: this.options.errors
        };
    },
    initialize: function(options) {
        var self = this;
        this.options = _.defaults(
            options || {},
            {
                theme: 'light',
                _appChannel: null,
                errors: null
            }
        );
    },
    onChildviewClickItem(view) {
      if (view.model.get('slug')) {
        this.options._appChannel.request(
            'load:product',
            view.model.get('slug')
        );
      }
    },
    onChildviewDeleteItem(view) {
      var self = this;
      var childView = this.children.findByModel(view.model);
      if (childView) {
          childView.hideItem();
      }
      this.options._appChannel.trigger('cart:remove:item', view.model);
      this.trigger('cart:remove:item', view.model);
      this.options._appChannel.trigger('cart:items:update:subtotals');
      this.collection.each(function(model) {
          if (model) {
            var childView = self.children.findByModel(model);
            if (childView) {
              childView._updateItemTotal();
            }
          }
      });
    },
    onChildviewCartItemQtyUpdated(view) {
      var self = this;
      this.options._appChannel.trigger('cart:items:update:subtotals');
      this.collection.each(function(model) {
          if (model) {
            var childView = self.children.findByModel(model);
            if (childView) {
              childView._updateItemTotal();
              if (parseInt(model.get('cartCount')) <= 0) {
                view.trigger('delete:item', this);
              }
            }
          }
      });

      this.options._appChannel.trigger('cart:items:updated');
    }
});

module.exports = CartItems;



/** WEBPACK FOOTER **
 ** ./assets/js/common/cart/cart-review/cart-items.js
 **/